import { RegistrationUser, RegistrationUserImpl } from "./RegistrationUser";

export interface InscriptionFlowRegistration {
  guid: string;
  registrationMode: number;
  registrationSubMode: number;
  formType: number;
  user: RegistrationUser;
  captchaSolution: string;
}

export class InscriptionFlowRegistrationImpl
  implements InscriptionFlowRegistration {
  constructor(
    guid: string,
    registrationMode: number,
    registrationSubMode: number,
    formType: number,
    user: RegistrationUser,
    captchaSolution: string
  ) {
    this.guid = guid;
    this.captchaSolution = captchaSolution;
    this.registrationMode = registrationMode;
    this.registrationSubMode = registrationSubMode;
    this.formType = formType;
    this.user = new RegistrationUserImpl(
      user.id,
      user.title,
      user.firstName,
      user.lastName,
      user.nationalId,
      user.email,
      user.phone,
      user.mobilePhone,
      user.comment,
      user.login,
      user.password,
      user.idSpeciality,
      user.labelSpeciality,
      user.idProfession,
      user.labelProfession
    );
  }

  guid = "";
  registrationMode: number;
  registrationSubMode: number;
  formType: number;
  user: RegistrationUser;
  captchaSolution: string;
}
